export const team = {
  addMember: {
    team: 'Tim',
    seeHowToUse: 'Pogledajte kako koristiti',
    help: 'Pomoć',
    addAMember: 'Dodaj člana',
    addYourTeamMembersText: 'Dodajte članove tima kao podršku agentima za razgovor uživo s korisnicima bota.',
    name: 'Ime',
    nameIsRequired: 'Ime je obavezno',
    email: 'Email',
    enterAValidEmail: 'Unesite ispravan email',
    password: 'Lozinka',
    passwordMustContain: 'Lozinka mora sadržavati',
    atleast6Characters: 'najmanje 6 znakova,',
    oneUpperCaseLetter: '1 veliko slovo',
    oneSpecialCharacter: '1 poseban znak*',
    profileIcon: 'Profilna ikona',
    whatsappNumber: 'WhatsApp broj',
    leadVisibility: 'Vidljivost potencijalnih kupaca*',
    addMember: 'Dodaj člana',
    role: 'Uloga',
    createdOn: 'Stvoreno',
    action: 'Akcija',
    updateMember: 'Ažuriraj člana',
    add: 'Dodaj',
    cancel: 'Otkaži',
    selectVisibilityOption: 'Odaberi opciju vidljivosti',
    all: 'Sve',
    assigned: 'Dodijeljeno',
    nA: 'N/A',
    admin: 'Admin',
    agent: 'Agent',
    placeholders: {
      enterMemberName: 'Unesite ime člana',
      enterMemberEmailAddress: 'Unesite email adresu člana',
      createPasswordForMember: 'Stvorite lozinku za člana',
      searchCountry: 'Pretraži državu',
      enterWhatsappNumber: 'Unesite WhatsApp broj',
      selectLeadsVisibility: 'Odaberite vidljivost potencijalnih kupaca',
      searchTeamByNameOrEmail: 'Pretražite člana tima po imenu ili emailu',
    },
    modal: {
      deleteTeamMember: 'Izbriši člana tima',
      wantToDeleteThisTeamMember: 'Jeste li sigurni da želite izbrisati ovog člana tima?',
    },
    appTooltip: {
      clickToAddNewTeamMember: 'Kliknite da biste dodali novog člana tima',
      profileIconOfTeamMember: 'Profilna ikona/slika člana tima',
      nameOfTeamMember: 'Ime člana tima',
      emailOfTeamMember: 'Email člana tima',
      whatsappNumberOfTeamMember: 'WhatsApp broj člana tima',
      roleOfTeamMemberAsAdminOrAgent: 'Uloga člana tima kao admin/agent',
      dateAndTimeOfCreatingTeamMemberRole: 'Datum i vrijeme stvaranja uloge člana tima',
      editOrDeleteTeamMember: 'Uredi/izbriši člana tima',
      editTeamMembersDetails: 'Uredi pojedinosti o članu tima.',
      removeAccessOfTeamMemberByDeletingAccount: 'Ukloni pristup člana tima brisanjem računa',
    }
  },
  users: {
    manageMembers: 'Upravljanje članovima',
    managerMembersWhichCanAccessPanel: 'Upravljajte članovima partner tima koji mogu pristupiti vašem panelu',
    createNewMember: 'Stvori novog člana',
    createMember: 'Stvori člana',
    updateMember: 'Ažuriraj člana',
    deleteTitleMember: 'Izbriši člana',
    deleteDescriptionMember: 'Jeste li sigurni da želite izbrisati ovog člana?',
    noMemberFound: 'Nema pronađenih članova!',
    titleMember: 'Stvori člana',
    manageUsers: 'Upravljanje korisnicima',
    createNewUser: 'Stvori novog korisnika',
    managerUserWhichCanAccessPanel: 'Upravljajte korisnicima koji mogu pristupiti vašem panelu',
    phoneNumber: 'Broj telefona',
    discard: 'Odbaci',
    createUser: 'Stvori korisnika',
    updateUser: 'Ažuriraj korisnika',
    noUserFOund: 'Nema pronađenih korisnika!',
    title: 'Stvori korisnika',
    profileIcon: 'Profilna ikona*',
    name: 'Ime*',
    email: 'Email*',
    password: 'Lozinka*',
    selectRole: 'Odaberi ulogu*',
    selectARole: 'Odaberi ulogu',
    selectLeadVisibility: 'Odaberi vidljivost potencijalnih kupaca*',
    confirmPassword: 'Potvrdi lozinku*',
    tableHeadingName: 'Ime',
    tableHeadingEmail: 'Email',
    tableHeadingPhoneNumber: 'Broj telefona',
    tableHeadingRole: 'Uloga',
    tableHeadingStatus: 'Status',
    tableHeadingAction: 'Akcija',
    deleteTitle: 'Izbriši korisnike',
    deleteDescription: 'Jeste li sigurni da želite izbrisati ovog korisnika?',
    placeholders: {
      searchHere: 'Pretraži ovdje',
      enterName: 'Unesite ime',
      enterEmail: 'Unesite email',
      searchCountry: 'Pretraži državu',
      enterPhoneNumber: 'Unesite broj telefona',
      enterPassword: 'Unesite lozinku',
      enterConfirmPassword: 'Potvrdite lozinku'
    },
    appTooltip: {
      TOOLTIP_DELETE_USERS: 'Izbriši korisnike',
      TOOLTIP_DELETE_MEMBERS: 'Izbriši članove'
    }
  },
  roles: {
    manageRoles: 'Upravljanje ulogama',
    manageYourRoles: 'Upravljajte svojim ulogama.',
    name: 'Ime*',
    description: 'Opis',
    discard: 'Odbaci',
    createRole: 'Stvori ulogu',
    creteARole: 'Stvori ulogu',
    updateRole: 'Ažuriraj ulogu',
    noUserFound: 'Nema pronađenih korisničkih uloga!',
    assignPermissions: 'Dodijeli dozvole*',
    tableHeadingName: 'Ime',
    tableHeadingDescription: 'Opis',
    tableHeadingStatus: 'Status',
    tableHeadingAction: 'Akcija',
    module: 'Modul',
    read: 'Čitanje',
    write: 'Pisanje',
    remove: 'Izbriši',
    notes: 'Bilješke',
    deleteTitle: 'Izbriši ulogu',
    deleteDescription: 'Upozorenje: Brisanjem ove uloge izbrisat će se i svi korisnici kojima je dodijeljena ova uloga. \n Jeste li sigurni da želite izbrisati ovu ulogu?',
    deleteMemberDescription: 'Upozorenje: Brisanjem ove uloge izbrisat će se i svi članovi kojima je dodijeljena ova uloga. \n Jeste li sigurni da želite izbrisati ovu ulogu?',
    placeholders: {
      enterRoleName: 'Unesite ime uloge',
      searchHere: 'Pretraži ovdje',
      enterDescriptionForRole: 'Unesite opis za ulogu'
    },
    appTooltip: {
      TOOLTIP_SECTION_TO_ALLOW_BLOCK: 'Odjeljci koje možete dopustiti ili blokirati korisnicima',
      TOOLTIP_CLICK_TO_ADD_ROLE: 'Kliknite da biste dodali novu ulogu',
    }
  },
  accessControl: {
    users: 'Korisnici',
    partnerTeam: 'Partner tim',
    members: 'Članovi',
    roles: 'Uloge'
  }
};

